export const LATLONGLAYER = 'LATLONGLAYER'